export default {
  name: 'marking--cancelReason',
};